import { tokenPocket, tokenPocketDark } from '../../../utils';

export default {
  product: {
    title: '제품',
    label_1: 'KeyPal',
    label_2: 'Secret Box',
    label_3: '가죽 케이스',
    label_4: '모든 액세서리',
    label_5: 'KeyPal 카드',
  },
  upgrade: {
    label_1: '업그레이드',
  },
  // learn 제목 아래 설명
  learn: {
    label_1: '안전',
  },
  others: {
    label_1: '소개',
    label_2: '개인정보 처리방침',
    label_3: '이용 약관',
  },
  support: {
    title: '지원',
    label_1: '도움말 센터',
    label_2: '구매 FAQ',
    label_3: '커뮤니티',
  },
  cryptoAssets: {
    title: '암호화 자산',
    label_1: '비트코인 지갑',
    label_2: '이더리움 지갑',
    label_3: 'Solana 지갑',
    label_4: 'Tron 지갑',
    label_5: '스테이블코인 지갑',
  },
  getStarted: {
    title: '시작하기',
    label_1: '지갑을 안전하게 지키는 방법은?',
    label_2: 'KeyPal 2 사용 방법',
    label_3: 'KeyPal Card 사용 방법',
    label_4: 'KeyPal Plus 사용 방법',
    label_5: 'Secret Box 사용 방법',
  },
  download: {
    title: '다운로드',
    label_1: '모바일 지갑',
    label_2: '확장 프로그램 지갑',
    label_3: '업그레이드',
  },
  legal: {
    title: '법률 정보',
    label_1: '개인정보 보호정책',
    label_2: '이용 약관',
  },

  designed: `${tokenPocket}이(가) 디자인함 ❤️`,
  designedDark: `${tokenPocketDark}이(가) 디자인함 ❤️`,
};
